export function normalizeRevisionSupplementalFacts(value = '') {
  const values = Array.isArray(value) ? value : String(value || '').split(/\r?\n+/);
  return [...new Set(values
    .map((item) => String(item || '').replace(/^\s*(?:[-*•]|\d+[.)、])\s*/, '').trim())
    .filter(Boolean))];
}

export function getRevisionExecutionAuthority(revisionSuggestionsMeta = null) {
  const raw = revisionSuggestionsMeta?.executionAuthority || {};
  return {
    actionable: raw.actionable === true,
    conclusion: String(raw.conclusion || '').trim().toLowerCase(),
    status: String(raw.status || '').trim().toLowerCase(),
    fullTextReviewFailed: raw.fullTextReviewFailed === true,
  };
}

export function buildRevisionFactQuestions({
  listingText = '',
  revisionSuggestionsMeta = null,
  serverQuestions = [],
} = {}) {
  const authority = getRevisionExecutionAuthority(revisionSuggestionsMeta);
  const questions = normalizeRevisionSupplementalFacts(serverQuestions);
  if (authority.conclusion !== 'facts_required' && !questions.length) return [];
  const visible = String(listingText || '');
  if (/\b(?:machine[\s-]?washable|washable|easy[\s-]?clean|spot[\s-]?clean)\b/i.test(visible)) {
    questions.push('请确认清洗方式：机洗、手洗还是仅局部清洁？请同时提供水温、程序与干燥方式。');
  }
  if (/\b(?:non[\s-]?slip|anti[\s-]?slip|slip[\s-]?resistant|tpr|rubber[\s-]?backed)\b/i.test(visible)) {
    questions.push('请确认是否自带防滑背衬、背衬材质，以及是否仍建议搭配额外 rug pad。');
  }
  if (!questions.length) {
    questions.push('请补充诊断中缺失的规格、材质、护理、兼容性或包装信息；无法确认的内容请不要填写。');
  }
  return [...new Set(questions)];
}

export function createRevisionFactsController({
  select,
  getState,
  getListingText,
  renderQuestions,
} = {}) {
  function collectSupplementalFacts() {
    return normalizeRevisionSupplementalFacts(
      select('#revision-supplemental-facts')?.value
      || getState('revisionSupplementalFacts')
      || []
    );
  }

  function render() {
    const panel = select('#revision-fact-panel');
    const list = select('#revision-fact-questions');
    const summary = select('#revision-fact-summary');
    const textarea = select('#revision-supplemental-facts');
    if (!panel || !list || !summary || !textarea) return;
    const questions = buildRevisionFactQuestions({
      listingText: getListingText(),
      revisionSuggestionsMeta: getState('revisionSuggestionsMeta'),
      serverQuestions: getState('revisionMissingFactQuestions') || [],
    });
    const facts = normalizeRevisionSupplementalFacts(getState('revisionSupplementalFacts') || []);
    if (textarea.value !== facts.join('\n')) textarea.value = facts.join('\n');
    renderQuestions(list, questions);
    list.hidden = questions.length === 0;
    panel.classList.remove('is-required');
    panel.open = questions.length > 0 || facts.length > 0;
    summary.textContent = questions.length
      ? `可选补充 ${questions.length} 项`
      : (facts.length ? `已补充 ${facts.length} 条` : '可选');
  }

  return { collectSupplementalFacts, render };
}
